import axios from "axios";
import { BASEURL } from "baseUrl";
import { toast } from "react-toastify";
import { doctorAppointmentAllCount } from "./Admin.action";

export const DOCTOR_ALL_APPOINTMENT = 'DOCTOR_ALL_APPOINTMENT'
export const ADD_SUGGESTION = 'ADD_SUGGESTION'
export const VIEW_ALL_SUGGESTION = 'VIEW_ALL_SUGGESTION'
export const DELETE_SUGGESTION = 'DELETE_SUGGESTION'
export const UPDATE_SUGGESTION = 'UPDATE_SUGGESTION'
export const VIEW_SUGGESTION_BY_ID = 'VIEW_SUGGESTION_BY_ID'
export const ADD_TREATMENT = 'ADD_TREATMENT'
export const GET_TREATMENT = 'GET_TREATMENT'
export const DELETE_TREATMENT = 'DELETE_TREATMENT'
export const UPDATE_TREATMENT = 'UPDATE_TREATMENT'
export const ADD_PARAMATERS = 'ADD_PARAMATERS'
export const GET_PARAMATERS = 'GET_PARAMATERS'
export const DELETE_PARAMATERS = 'DELETE_PARAMATERS'
export const UPDATE_PARAMATERS = 'UPDATE_PARAMATERS'
export const ADD_FUTURE_SUGGESTION = 'ADD_FUTURE_SUGGESTION'
export const GET_FUTURE_SUGGESTION = 'GET_FUTURE_SUGGESTION'
export const DELETE_FUTURE_SUGGESTION = 'DELETE_FUTURE_SUGGESTION'
export const UPDATE_FUTURE_SUGGESTION = 'UPDATE_FUTURE_SUGGESTION'
export const ADD_REMARK = 'ADD_REMARK'
export const GET_REMARK = 'GET_REMARK'
export const DELETE_REMARK = 'DELETE_REMARK'
export const UPDATE_REMARK = 'UPDATE_REMARK'
export const MEDICINE_PRINT = 'MEDICINE_PRINT'
export const PATIENT_CALL_LOG = 'PATIENT_CALL_LOG'
export const MEDICINE_PACKAGE = 'MEDICINE_PACKAGE'
export const DATE_APPOINTMENT = 'DATE_APPOINTMENT'
export const GET_DATE_APPOINTMENT = 'GET_DATE_APPOINTMENT'
export const GET_DOCTOR_APPOINTMENT = 'GET_DOCTOR_APPOINTMENT'
export const UPDATE_DATE_APPOINTMENT = 'UPDATE_DATE_APPOINTMENT'

const allDoctorAppointmentAction = (payload) => ({ type: DOCTOR_ALL_APPOINTMENT, payload: payload });
const addSuggestionAction = (payload) => ({ type: ADD_SUGGESTION, payload: payload });
const viewAllAction = (payload) => ({ type: VIEW_ALL_SUGGESTION, payload: payload });
const deleteSuggestionAction = (payload) => ({ type: DELETE_SUGGESTION, payload: payload });
const updateSuggestionAction = (payload) => ({ type: UPDATE_SUGGESTION, payload: payload });
const viewSuggestionByIdAction = (payload) => ({ type: VIEW_SUGGESTION_BY_ID, payload: payload });
const addTreatmentAction = (payload) => ({ type: ADD_TREATMENT, payload: payload });
const getTreatmentAction = (payload) => ({ type: GET_TREATMENT, payload: payload });
const deleteTreatmentAction = (payload) => ({ type: DELETE_TREATMENT, payload: payload });
const updateTreatmentAction = (payload) => ({ type: UPDATE_TREATMENT, payload: payload });
const addParamatersAction = (payload) => ({ type: ADD_PARAMATERS, payload: payload });
const getParamatersAction = (payload) => ({ type: GET_PARAMATERS, payload: payload });
const deleteParamatersAction = (payload) => ({ type: DELETE_PARAMATERS, payload: payload });
const updateParamatersAction = (payload) => ({ type: UPDATE_PARAMATERS, payload: payload });
const addFutureSuggestionAction = (payload) => ({ type: ADD_FUTURE_SUGGESTION, payload: payload });
const getFutureSuggestionAction = (payload) => ({ type: GET_FUTURE_SUGGESTION, payload: payload });
const deleteFutureSuggestionAction = (payload) => ({ type: DELETE_FUTURE_SUGGESTION, payload: payload });
const updateFutureSuggestionAction = (payload) => ({ type: UPDATE_FUTURE_SUGGESTION, payload: payload });
const addRemarkAction = (payload) => ({ type: ADD_REMARK, payload: payload });
const getRemarkAction = (payload) => ({ type: GET_REMARK, payload: payload });
const updateRemarkAction = (payload) => ({ type: UPDATE_REMARK, payload: payload });
const deleteRemarkAction = (payload) => ({ type: DELETE_REMARK, payload: payload });
const medicinePrintAction = (payload) => ({ type: MEDICINE_PRINT, payload: payload });
const patientCallLogAction = (payload) => ({ type: PATIENT_CALL_LOG, payload: payload });
const medicinePackageAction = (payload) => ({ type: MEDICINE_PACKAGE, payload: payload });
const dateAppointmentAction = (payload) => ({ type: DATE_APPOINTMENT, payload: payload });
const getDateAppointmentAction = (payload) => ({ type: GET_DATE_APPOINTMENT, payload: payload });
const getDoctorAppointmentAction = (payload) => ({ type: GET_DOCTOR_APPOINTMENT, payload: payload });
const updateDoctorAppointmentAction = (payload) => ({ type: UPDATE_DATE_APPOINTMENT, payload: payload });

export const allDoctorAppointment = (limits, currentDate,search,issue) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.get(`${BASEURL}/appointment/doctorWiseAppointment?page=${limits.page}&limit=${limits.limit}&date=${currentDate}&search=${search}&issue=${issue}`, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(((res) => {
                dispatch(allDoctorAppointmentAction(res));
                dispatch(doctorAppointmentAllCount(currentDate))
            })).catch((error) => {
                console.log("Error", error);
                dispatch(allDoctorAppointmentAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const addSuggestion = (payload, patientIds, limits) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.post(`${BASEURL}/clinical/addTreatment`, payload, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(((res) => {
                dispatch(addSuggestionAction(res));
                dispatch(viewAllSuggestion(patientIds, limits))
                toast.success('Suggestion Add Succesfully')
            })).catch((error) => {
                console.log("Error", error);
                toast.error('Something went wrong')
                dispatch(addSuggestionAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const viewAllSuggestion = (patientIds, limits) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/clinical/viewAllTreatment/${patientIds}?limit=${limits.limit}&page=${limits.page}`).then(((res) => {
                dispatch(viewAllAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(viewAllAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const deleteSuggestion = (suggestionId, patientIds, limits) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${BASEURL}/clinical/deleteTreatment/${suggestionId}`).then(((res) => {
                dispatch(deleteSuggestionAction(res));
                dispatch(viewAllSuggestion(patientIds, limits))
                toast.success('Delete Suggestion Successfully')
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(deleteSuggestionAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const updateSuggestion = (payload, suggestionId, patientIds, limits) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.put(`${BASEURL}/clinical/updateTreatment/${suggestionId}`, payload, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(((res) => {
                dispatch(updateSuggestionAction(res));
                dispatch(viewAllSuggestion(patientIds, limits))
                toast.success('Update Suggestion Successfully')
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(updateSuggestionAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const viewSuggestionById = (suggestionId) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/clinical/viewTreatment/${suggestionId}`).then(((res) => {
                dispatch(viewSuggestionByIdAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(viewSuggestionByIdAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const addTreatment = (payload, limits, patientIds) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.post(`${BASEURL}/clinical/addTreatmentInfo`, payload, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(((res) => {
                dispatch(addTreatmentAction(res));
                dispatch(getTreatment(limits, patientIds))
                toast.success('Treatment Add Succesfully')
            })).catch((error) => {
                console.log("Error", error);
                toast.error('Something went wrong')
                dispatch(addTreatmentAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const getTreatment = (limits, patientIds) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/clinical/viewAllTreatmentInfo/${patientIds}?limit=${limits.limit}&page=${limits.page}`).then(((res) => {
                dispatch(getTreatmentAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getTreatmentAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const deleteTreatment = (limits, patientIds, treatmentId) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${BASEURL}/clinical/deleteTreatmentInfo/${treatmentId}`).then(((res) => {
                dispatch(deleteTreatmentAction(res));
                dispatch(getTreatment(limits, patientIds))
                toast.success('Delete Treatment Successfully')
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(deleteTreatmentAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const updateTreatment = (payload, treatmentId, patientIds, limits) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.put(`${BASEURL}/clinical/updateTreatmentInfo/${treatmentId}`, payload, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(((res) => {
                dispatch(updateTreatmentAction(res));
                dispatch(getTreatment(limits, patientIds))
                toast.success('Update Suggestion Successfully')
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(updateTreatmentAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const addParamaters = (payload, limits, patientIds) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.post(`${BASEURL}/clinical/createParameter`, payload, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(((res) => {
                dispatch(addParamatersAction(res));
                dispatch(getParamaters(limits, patientIds))
                toast.success('Paramaters Add Succesfully')
            })).catch((error) => {
                console.log("Error", error);
                toast.error('Something went wrong')
                dispatch(addParamatersAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const getParamaters = (limits, patientIds) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/clinical/getAllParameters/${patientIds}?limit=${limits.limit}&page=${limits.page}`).then(((res) => {
                dispatch(getParamatersAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getParamatersAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const deleteParamaters = (limits, patientIds, treatmentId) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${BASEURL}/clinical/deleteParameter/${treatmentId}`).then(((res) => {
                dispatch(deleteParamatersAction(res));
                dispatch(getParamaters(limits, patientIds))
                toast.success('Delete Paramaters Successfully')
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(deleteParamatersAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const updateParamaters = (payload, treatmentId, patientIds, limits) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.put(`${BASEURL}/clinical/updateParameter/${treatmentId}`, payload, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(((res) => {
                dispatch(updateParamatersAction(res));
                dispatch(getParamaters(limits, patientIds))
                toast.success('Update Paramaters Successfully')
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(updateParamatersAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const addFutureSuggestion = (payload, limits, patientIds) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.post(`${BASEURL}/clinical/createFutureSuggestion`, payload, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(((res) => {
                dispatch(addFutureSuggestionAction(res));
                dispatch(getFutureSuggestion(limits, patientIds))
                toast.success('Suggestion Add Succesfully')
            })).catch((error) => {
                console.log("Error", error);
                toast.error('Something went wrong')
                dispatch(addFutureSuggestionAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const getFutureSuggestion = (limits, patientIds) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/clinical/getAllFutureSuggestions/${patientIds}?limit=${limits.limit}&page=${limits.page}`).then(((res) => {
                dispatch(getFutureSuggestionAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getFutureSuggestionAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const deleteFutureSuggestion = (limits, patientIds, treatmentId) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${BASEURL}/clinical/deleteFutureSuggestion/${treatmentId}`).then(((res) => {
                dispatch(deleteFutureSuggestionAction(res));
                dispatch(getFutureSuggestion(limits, patientIds))
                toast.success('Delete Suggestion Successfully')
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(deleteFutureSuggestionAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const updateFutureSuggestion = (payload, treatmentId, patientIds, limits) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.put(`${BASEURL}/clinical/updateFutureSuggestion/${treatmentId}`, payload, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(((res) => {
                dispatch(updateFutureSuggestionAction(res));
                dispatch(getFutureSuggestion(limits, patientIds))
                toast.success('Update Suggestion Successfully')
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(updateFutureSuggestionAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const addRemark = (payload, limits, patientIds) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.post(`${BASEURL}/clinical/createDoctorRemark`, payload, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(((res) => {
                dispatch(addRemarkAction(res));
                dispatch(getRemark(limits, patientIds))
                toast.success('Paramaters Add Succesfully')
            })).catch((error) => {
                console.log("Error", error);
                toast.error('Something went wrong')
                dispatch(addRemarkAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const getRemark = (limits, patientIds) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/clinical/getAllDoctorRemarks/${patientIds}?limit=${limits.limit}&page=${limits.page}`).then(((res) => {
                dispatch(getRemarkAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getRemarkAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const deleteRemark = (limits, patientIds, treatmentId) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${BASEURL}/clinical/deleteDoctorRemark/${treatmentId}`).then(((res) => {
                dispatch(deleteRemarkAction(res));
                dispatch(getRemark(limits, patientIds))
                toast.success('Delete Paramaters Successfully')
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(deleteRemarkAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const updateRemark = (payload, treatmentId, patientIds, limits) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.put(`${BASEURL}/clinical/updateDoctorRemark/${treatmentId}`, payload, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(((res) => {
                dispatch(updateRemarkAction(res));
                dispatch(getRemark(limits, patientIds))
                toast.success('Update Paramaters Successfully')
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(updateRemarkAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const medicinePrint = (id, payload) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/clinical/printMedicin/${id}`, payload).then(((res) => {
                dispatch(medicinePrintAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(medicinePrintAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const patientCallLog = (id, limits) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/receptionist/getcallLogHistory/${id}?page=${limits.page}&limit=${limits.limit}`).then(((res) => {
                dispatch(patientCallLogAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(patientCallLogAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const medicinePackage = (id) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/clinical/getGroupedMedicineByDate/${id}`).then(((res) => {
                dispatch(medicinePackageAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(medicinePackageAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const dateAppointment = (payload, payload1, limits) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.post(`${BASEURL}/appointment/appointmentByDoctors`, payload, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(((res) => {
                dispatch(dateAppointmentAction(res));
                dispatch(getDateAppointment(payload1, limits))
                toast.success('Next Appointment Set Successfully!')
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(dateAppointmentAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const getDateAppointment = (payload, limits) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.get(`${BASEURL}/appointment/getAppointmentByDoctors/${payload.patientId}?limit=${limits.limit}&page=${limits.page}`, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(((res) => {
                dispatch(getDateAppointmentAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getDateAppointmentAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const updateDateAppointment = (payload, payload1, limits) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.post(`${BASEURL}/appointment/doctorAppointmentUpdate`, payload, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(((res) => {
                dispatch(updateDoctorAppointmentAction(res));
                dispatch(getDateAppointment(payload1, limits))
                toast.success('Next Appointment Update Successfully!')
            })).catch((error) => {
                console.log("Error", error);
                dispatch(updateDoctorAppointmentAction(error?.response));
                toast.error(error?.response?.data?.message)
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const getDoctorAppointment = (limits, selectedDate, searchQuery,issue) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.get(`${BASEURL}/appointment/doctorWiseAllAppointment?page=${limits.page}&limit=${limits.limit}&date=${selectedDate}&searchValue=${searchQuery}&issue=${issue}`, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(((res) => {
                dispatch(getDoctorAppointmentAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getDoctorAppointmentAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

